/**
 * D-036 Retro-Aggregation für die Quartalsebene (S1/Stufe 2).
 *
 * „Kennzeichnen statt Korrigieren": leitet aus den monatlichen retro_hinweise
 * ab, welche Quartale eine SICHERE Quartalsgrenz-Überschreitung tragen.
 *
 * R1 (konservativ, Entscheidung Tom-Eric): retro.py liefert nur den Buchungs-/
 * Ausweismonat, keinen Ursprungsmonat. Eine Grenzüberschreitung ist nur dann
 * deterministisch sicher, wenn der Ausweismonat der ERSTE Monat seines Quartals
 * ist (4/7/10) — dann liegt der jüngstmögliche Ursprung (Monat−1) zwingend im
 * Vorquartal. Übrige Ausweismonate bleiben bewusst ohne Quartals-Badge (mögliche
 * False Negatives, im UI-Tooltip offengelegt). Januar (Q1-Erstmonat) hat nie
 * einen Retro-Hinweis (kein Vormonat → pruefluecke ERSTER_STICHTAG).
 */
import type { QuarterKey, RetroHinweis } from '../types/snapshot';

/**
 * Quartals-Erstmonat → Quartal. Die Jahresbindung (q2_2026 …) folgt dem
 * bestehenden jahresgebundenen QuarterKey-Typ von Schema 2.0; beim Jahreswechsel
 * wird sie gemeinsam mit dem Schema (Quarterly-Keys) angefasst.
 */
const QUARTAL_ERSTMONAT: Record<number, QuarterKey> = {
  4: 'q2_2026',
  7: 'q3_2026',
  10: 'q4_2026',
};

export interface QuartalsGrenzRetro {
  quartal: QuarterKey;
  ausweismonat: number;
  betrag: number; // Σ der Kategorie-Werte des Grenz-Hinweises
  kategorien: Record<string, number>;
}

/** Sichere Quartalsgrenz-Retros je Quartal (R1). Leer-tolerant. */
export function quartalsGrenzRetros(hinweise?: RetroHinweis[]): QuartalsGrenzRetro[] {
  if (!hinweise) return [];
  const out: QuartalsGrenzRetro[] = [];
  for (const h of hinweise) {
    const quartal = QUARTAL_ERSTMONAT[h.monat];
    if (!quartal) continue; // kein Quartals-Erstmonat → keine sichere Grenze (R1)
    const betrag = Object.values(h.kategorien).reduce((a, b) => a + b, 0);
    out.push({ quartal, ausweismonat: h.monat, betrag, kategorien: h.kategorien });
  }
  return out;
}
